module.exports = __webpack_public_path__ + "static/media/cardviewgreen.87ddd026.svg";